export default __webpack_public_path__ + "static/media/Pickpocket's Belt of the Nadir.dfe592ad.jpg";